import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CourseSoldOutTip from "@/modules/stu/components/CourseSoldOutTip.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import FileList from "@/modules/stu/components/FileList";
import CoursePeriodsType from "@/modules/stu/components/CoursePeriodsType";
import CourseContentTip from "@/modules/stu/components/CourseContentTip";
import { CoursePeriodsType as CoursePeriodsTypeFun } from "@/utils/enums";
export default {
  name: "MemberStudyPeriod",
  components: {
    CourseSoldOutTip: CourseSoldOutTip,
    ProgressBar: ProgressBar,
    FileList: FileList,
    CoursePeriodsType: CoursePeriodsType,
    CourseContentTip: CourseContentTip
  },
  props: {
    period: {
      type: Object
    },
    course_type: {
      type: Number
    },
    course_id: {
      type: Number
    },
    showDownload: {
      type: Boolean,
      default: false
    },
    course: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      showContentDialog: false,
      chapter_content: "",
      showSoldOut: false
    };
  },
  created: function created() {
    var isLive = function isLive(start, end) {
      //  1未开播  2直播中  3直播结束
      if (start == 0) {
        return 1;
      } //未开播


      if (start != 0 && end == '') {
        return 2;
      } //直播中


      if (start != 0 && end != '') {
        return 3;
      } //直播结束

    };

    this.period.play_type = isLive(this.period.start_op_time, this.period.end_op_time);
  },
  computed: {
    commonSetting: function commonSetting() {
      return this.$store.state.commonSetting;
    },
    courseType: function courseType() {
      return this.period.periods_type;
    },
    is_Live: function is_Live() {
      return CoursePeriodsTypeFun.getValue(this.period.periods_type);
    }
  },
  methods: {
    //处理课时课件文件
    getFile: function getFile(data) {
      if (data && data.length > 0) {
        return data.map(function (item) {
          return _objectSpread({}, item, {
            ware_filename: item.file_name
          });
        });
      }

      return [];
    },
    check: function check() {
      if (this.course.status == 2 && this.course.is_go_to_study == 0) {
        this.showSoldOut = true;
        return false;
      }

      return true;
    },
    visitFile: function () {
      var _visitFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(id, index) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.check()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return this.$services.CourseService.openPeriodFile(this.period, id, index);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function visitFile(_x, _x2) {
        return _visitFile.apply(this, arguments);
      }

      return visitFile;
    }(),
    targetPeriod: function () {
      var _targetPeriod = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(period, type) {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                period.play_type = period.play_type == 3 ? 4 : period.play_type;

                if (this.check()) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                if (this.$services.CourseService.checkLiveState(this.courseType, period, type)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                if (!(this.course.valid_status != 1)) {
                  _context2.next = 8;
                  break;
                }

                this.$info("该课程已过期，无法继续学习");
                return _context2.abrupt("return");

              case 8:
                if (!(this.period.periods_type == 7 && this.period.content)) {
                  _context2.next = 12;
                  break;
                }

                this.chapter_content = this.period.content;
                this.showContentDialog = true;
                return _context2.abrupt("return");

              case 12:
                _context2.next = 14;
                return this.$services.CourseService.checkLimit(this.course_id);

              case 14:
                if (!(this.courseType == 10)) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 17;
                return this.$services.CourseService.getPeriodContent(period);

              case 17:
                data = _context2.sent;
                this.chapter_content = data.course_content;
                this.showContentDialog = true;
                _context2.next = 25;
                break;

              case 22:
                if (this.courseType == 16) {
                  if (!type) {
                    type = 2;
                  }
                } else if (!type) {
                  type = 1;
                }

                _context2.next = 25;
                return this.$services.CourseService.watchVideo(period, this.courseType, this.course_id, type);

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function targetPeriod(_x3, _x4) {
        return _targetPeriod.apply(this, arguments);
      }

      return targetPeriod;
    }()
  }
};